import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const state = {
  data: {},
  open: false,
  giftWrapItems: [],
  giftWrapOpen: false,
  giftFormOpen: false,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
